// extracted by mini-css-extract-plugin
export var growableInput = "_9b-0";
export var tagContainer = "_9b-2";
export var textInput = "_9b-1";